import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "135",
  height: "32",
  fill: "none",
  viewBox: "0 0 135 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#E6000E",
      "fill-rule": "evenodd",
      d: "M2.423 10.485c0-2.184.863-4.242 2.433-5.793a8.28 8.28 0 0 1 5.855-2.406h19.14v4.166h-19.14a4.08 4.08 0 0 0-2.877 1.186 4 4 0 0 0-1.2 2.847L6.61 17.48c-.195 1.858-1.611 3.356-3.442 3.632l-.745.113zM2.423 29.714v-4.167h19.14a4.06 4.06 0 0 0 2.875-1.187 3.97 3.97 0 0 0 1.201-2.845l.003-6.638c0-1.977 1.49-3.691 3.465-3.99l.744-.111v10.739a8.1 8.1 0 0 1-2.434 5.793 8.27 8.27 0 0 1-5.854 2.406z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#E6000E",
      "fill-rule": "evenodd",
      d: "M18.664 21.225v-5.31l-2.528 2.906-2.528-2.906v5.31h-3.35v-10.45h3.173l2.705 3.36 2.704-3.36h3.174v10.45zM67.609 18.225h-3.606l1.803-4.706zm1.213 3.171.804 2.103h3.966L67.628 8.5h-3.586l-5.965 14.999h3.905l.806-2.103zM51.756 23.5v-8.914l-3.872 4.708-3.87-4.708V23.5h-3.877v-15h3.824l3.923 5.158 3.924-5.157h3.825V23.5zM76.058 8.5V23.5h3.88V11.984h5.421V8.501zm21.677 9.123V23.5h3.878V8.5h-3.878v5.598h-5.76V8.5h-3.877V23.5h3.877v-5.876zm28.259 5.876V11.984h-4.531V8.501h12.96v3.483h-4.551V23.5zm-11.136-8.548V23.5h3.88V8.5h-3.349l-6.067 8.458V8.501h-3.88V23.5h3.244z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }